import { canv } from '@/canv/global.js'

export class shapeCross {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width/2 - 2 * horizontalPadding;
        var allowedHeight = height/2 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width / 4, y);
        canv.ctx.lineTo(x + width * 3/4, y);
        canv.ctx.lineTo(x + width * 3/4, y + height/4);
        canv.ctx.lineTo(x + width, y + height/4);
        canv.ctx.lineTo(x + width, y + height * 3/4);
        canv.ctx.lineTo(x + width * 3/4, y + height * 3/4);
        canv.ctx.lineTo(x + width * 3/4, y + height);
        canv.ctx.lineTo(x + width/4, y + height);
        canv.ctx.lineTo(x + width/4, y + height * 3/4);
        canv.ctx.lineTo(x, y + height * 3/4);
        canv.ctx.lineTo(x, y + height/4);
        canv.ctx.lineTo(x + width/4, y + height/4);
        canv.ctx.lineTo(x + width / 4, y);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M76 20H60V4C60 2.93912 59.5784 1.92172 58.8284 1.17156C58.0784 0.42144 57.0608 0 56 0H24C22.9391 0 21.9217 0.42144 21.1716 1.17156C20.4214 1.92172 20 2.93912 20 4V20H4C2.93912 20 1.92172 20.4214 1.17156 21.1716C0.42144 21.9217 0 22.9391 0 24V56C0 57.0608 0.42144 58.0784 1.17156 58.8284C1.92172 59.5784 2.93912 60 4 60H20V76C20 77.0608 20.4214 78.0784 21.1716 78.8284C21.9217 79.5784 22.9391 80 24 80H56C57.0608 80 58.0784 79.5784 58.8284 78.8284C59.5784 78.0784 60 77.0608 60 76V60H76C77.0608 60 78.0784 59.5784 78.8284 58.8284C79.5784 58.0784 80 57.0608 80 56V24C80 22.9391 79.5784 21.9217 78.8284 21.1716C78.0784 20.4214 77.0608 20 76 20Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.25 6.25V6.75H18.75H23.75C23.9489 6.75 24.1397 6.82904 24.2803 6.96964C24.421 7.11034 24.5 7.30114 24.5 7.5V17.5C24.5 17.6989 24.4209 17.8897 24.2803 18.0303C24.1397 18.1709 23.9489 18.25 23.75 18.25H18.75H18.25V18.75V23.75C18.25 23.9489 18.1709 24.1397 18.0303 24.2803C17.8897 24.4209 17.6989 24.5 17.5 24.5H7.5C7.30114 24.5 7.11034 24.421 6.96963 24.2803C6.82904 24.1397 6.75 23.9489 6.75 23.75V18.75V18.25H6.25H1.25C1.05114 18.25 0.860338 18.171 0.719628 18.0303C0.579039 17.8897 0.5 17.6989 0.5 17.5V7.5C0.5 7.3011 0.579011 7.11034 0.719657 6.96968C0.860321 6.82902 1.05109 6.75 1.25 6.75H6.25H6.75V6.25V1.25C6.75 1.05109 6.82902 0.860321 6.96968 0.719657C7.11034 0.579011 7.3011 0.5 7.5 0.5H17.5C17.6989 0.5 17.8897 0.579039 18.0303 0.719638C18.171 0.860338 18.25 1.05114 18.25 1.25V6.25Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
